'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_CURRENCY = exports.DEFAULT_CURRENCY = 'EUR';
var DEFAULT_CURRENCY_SYMBOL = exports.DEFAULT_CURRENCY_SYMBOL = '€';

exports.default = {
  DEFAULT_CURRENCY: DEFAULT_CURRENCY,
  DEFAULT_CURRENCY_SYMBOL: DEFAULT_CURRENCY_SYMBOL
};
//# sourceMappingURL=constants.js.map